import { getContrast } from 'polished'
import { MIN_CONTRAST_RATIO_ON_WHITE } from '../theme/buildTheme.js'

export const doColorsMeetContrastRequirements = (colour1, colour2, minRatio = MIN_CONTRAST_RATIO_ON_WHITE) => getContrast(colour1, colour2) >= minRatio
